module.exports = __webpack_public_path__ + "img/Frame 7654.3657fbc8.svg";